import React from "react";

export const FormSection: React.FC<
  React.PropsWithChildren<{ title: string; description?: string }>
> = ({ title, description, children }) => (
  <section className="flex flex-col gap-4 rounded-lg border border-gray-200 bg-white p-4 md:p-6">
    <div>
      <h2 className="text-lg text-text-primary">{title}</h2>
      {description && (
        <p className="mt-1 text-sm text-gray-600">{description}</p>
      )}
    </div>
    {children}
  </section>
);

export const FieldHint: React.FC<React.PropsWithChildren> = ({ children }) => (
  <p className="ml-1 text-sm text-gray-600">{children}</p>
);
